import React from "react";
import SEO from "../components/seo";
import BackgroundSlide from "../components/backgroundSlide";
import { Box } from 'rebass';
import theme from "../gatsby-plugin-theme-ui";
import { graphql } from "gatsby";

const ClientSideOnlyGame = React.lazy(() =>
	import("../modules/game")
);

const TeaTime = ({ data }) => {
	const isBrowser = typeof window !== `undefined`;
	const { ogImage } = data;
	return (
		<>
			<SEO title="tea time" image={ogImage} />
			<Box height={[`calc(100vh - 2 * ${theme.space[2]}px)`, null, `calc(100vh - 2 * ${theme.space[2]}px)`]} width="100%" sx={{ position: 'relative' }}>
				{isBrowser && (
					<React.Suspense fallback={<div />}>
						<BackgroundSlide
							defaultBg={<ClientSideOnlyGame />}
							darkBg={<ClientSideOnlyGame dark />}
						/>
					</React.Suspense>
				)}
			</Box>
		</>
	)
};

export default TeaTime;

export const query = graphql`
    query {
        ogImage: file(name: {eq: "og_tea-time"}) {
            ...ogImageFragment
        }
    }
`
